<template>
  <div class="h-full relative shadow-md bg-white dark:bg-dark-400" style="border-radius: 1rem">
    <div class="text-base absolute top-0 left-0 ml-4 mt-3 text-gray-500 dark:text-dark-text">
      {{ label }}
    </div>
    <div :class="`${fontSize} text-center flex items-center justify-center h-full mt-1`">
      {{ value }}
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    fontSize: {
      type: String,
      required: true
    }
  },
  setup() {
    return {}
  }
})
</script>
<style lang="postcss" scoped></style>
